<template>
  <v-card class="py-3" flat>
    <v-card-title class="text-center justify-center">
      {{ title }}
    </v-card-title>
    <p class="text-center">{{ description }}</p>

    <v-card-title
      v-if="!newPosition && !single"
      class="flex-wrap justify-center pt-0"
    >
      <v-btn
        :class="gallery === 'allPic' ? 'activeBtn' : ''"
        class="px-3"
        min-width="36"
        text
        @click="gallery = 'allPic'"
      >
        {{ $t("all") }}
      </v-btn>

      <v-btn
        v-for="({ name }, i) in value"
        :key="i"
        :class="gallery === name ? 'activeBtn' : ''"
        min-width="36"
        text
        @click="gallery = name"
      >
        {{ name }}
      </v-btn>
    </v-card-title>

    <v-row v-if="!newPosition" no-gutters>
      <intro-slider
        v-model="getObj"
        :hide-overlay="hideOverlay"
        :is-slider="true"
        :loop="false"
        :type="type"
      />
    </v-row>

    <template v-if="newPosition">
      <v-row v-for="(item, i) in value" :key="i" no-gutters>
        <p class="mr-3 mt-2">
          {{ item.name }}
        </p>
        <intro-slider
          v-model="item.images"
          :hide-overlay="hideOverlay"
          :is-slider="true"
          :loop="false"
          :type="type"
          class="px-3"
          :orientation="orientation"
        />
      </v-row>
    </template>
  </v-card>
</template>

<script>
import IntroSlider from "@/view/pages/businessPage/components/view/bIntroSliderView";

export default {
  name: "gallerySlider",

  components: { IntroSlider },

  props: {
    value: Array,
    title: String,
    description: String,
    isImg: {
      type: Boolean,
      default: true,
    },
    type: String,
    newPosition: {
      type: Boolean,
      default: true,
    },
    hideOverlay: Boolean,
    single: Boolean,
    orientation:{
      type: String,
      default: 'horizontal',
    },
  },

  data: () => ({
    gallery: "allPic",
  }),

  computed: {
    getObj() {
      if (this.gallery === "allPic") {
        let arrays = this.value?.map((item) => item.images);
        return arrays?.reduce((acc, curr) => {
          return acc.concat(curr);
        }, []);
      }

      return this.value.find((item) => item.name === this.gallery).images;
    },
  },

  watch: {
    value: {
      deep: true,

      handler() {
        this.$forceUpdate();
      },
    },
  },
};
</script>

<style scoped>
.activeBtn {
  color: var(--primary);
  border-bottom: 1px solid var(--primary);
}
</style>
